import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#fc3',
    className: null,
};

const FooterTopLine = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="480px"
        height="2px"
        viewBox="0 0 480 2"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M474.9,0.9c-0.5,0-1.2-0.1-1.3-0.1c-1,0-1.2,0-1.4-0.1c-0.6-0.2-2.4-0.1-3.5-0.1c-1.5,0.2-3,0-4.5,0
		c-0.9,0-2.1,0.1-2.8,0.1c-2.2-0.1-4.6-0.1-6.8-0.1c-1.5,0-2.2,0-3.2-0.2c-0.4,0.1-0.6,0.2-0.9,0.4c-2.7-0.3-5.6-0.3-8.7-0.2
		c-0.6-0.1-1.1-0.1-1.7-0.2c-0.6,0-1.1,0.1-1.6,0.1c-0.5,0-1,0.1-1.9,0.1c-0.3-0.1-0.6-0.1-0.6-0.1c-1.9,0-3.5,0.1-4.7,0.1
		c-2.5-0.1-4.7,0-7.1,0c-2.4,0-5.2,0.1-6.8-0.1c-1.1,0-2,0.1-2.9,0.1c-0.9,0-1.8-0.1-2.8-0.1c-0.6,0.1-1.5,0.2-3.1,0.1
		c-1,0-2-0.1-3-0.1c-1.5,0-3-0.1-3.5,0.1c-1.3-0.1-2.3-0.1-3.5-0.2c-0.8,0.1-1.3,0.1-2.2,0.2c-0.3-0.1-0.6-0.2-0.8-0.2
		c-1.4,0-2.8,0-2.6,0.2c-1,0-1.9,0-2.8,0c-0.7,0-1.5,0-2,0c-1.7-0.1-3.3-0.2-5.1,0c-0.1,0-0.5,0-0.7,0c-1.2-0.1-2.6,0-3.9-0.1
		c-0.6,0-1.2-0.1-1.8-0.1c-2.1,0.1-2.1,0.1-6.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-3.3-0.1-6.6-0.2-9.9,0c-2.4-0.1-5.4,0.1-7.1-0.1
		c-1.3,0-2.2,0.1-3.1,0.1c-0.6-0.1-1.1-0.1-1.8-0.2c-0.5,0.1-0.9,0.1-1,0.2c-1.9,0-3.4-0.1-4.7-0.1c-1.6,0-3.1,0-4.5-0.1
		c-0.4,0-1,0-1.6-0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-1.7-0.1-3.2-0.1-4.7-0.2c-0.2,0-0.4,0-0.6,0c-0.8,0.1-1.6,0.1-2.5,0.2
		c-0.2,0-0.6-0.1-0.9-0.2c-1.1,0-2,0.1-2.9,0.1c-0.7,0-1.3-0.1-1.7-0.1c-1.2,0-2.3,0.1-3.3,0.1c-4.1-0.1-8.3,0-12.4-0.1
		c-0.5,0-1.4,0-1.7,0c-2.6,0.2-5.5,0-8.2,0c-2-0.2-3.1,0-4.4,0.1c-1.6-0.2-3.2-0.3-5.2-0.1c-0.3,0-1,0-1.3,0c-2.2-0.1-3.7,0-5.2,0.2
		c-0.4-0.1-0.8-0.2-0.9-0.2c-2.5,0.1-4.9,0-7.3,0c-3.1,0-6.1,0.1-9.3,0c-1.9,0.1-3.6,0-5.3-0.1c-0.6,0-1.7,0-1.9,0
		c-1.7,0.3-3,0-4.4,0c-2.8,0.1-3.2,0.1-3.5-0.2c-0.8,0.1-1.4,0.2-2.2,0.3c-1.8-0.2-4.6,0-6.5-0.2c-0.4,0.1-0.8,0.2-1.3,0.3
		c-1.5-0.1-2.7-0.2-4.1-0.3c-2.3,0.2-4.8,0-7.2,0c0,0,0,0.1,0,0.1c-2.2,0-3.9,0-5.1-0.2c-1.4,0-2.2,0.3-4,0.1
		c-2.3-0.2-2.5,0.1-3.5,0.2c-1.2-0.1-2-0.4-4.1-0.1c-0.6-0.1-1.2-0.2-1.7-0.2c-1.3,0.1-2.1,0.1-3,0.1c-0.4-0.1-0.7-0.1-0.9-0.1
		c-1.2,0.1-2.4,0.1-3.6,0.2c-0.4-0.1-0.8-0.1-1.3-0.2c-0.7,0.1-1.3,0.1-2.3,0.2c-0.4-0.1-0.8-0.2-1.2-0.2c-2.2,0.2-4.4,0.2-6.3,0.1
		c-2.9-0.1-5.5-0.1-7.9,0c-1.3,0-2.5,0-3.5-0.1c-1.5-0.1-1.9,0.2-3.2,0.1c-0.6-0.1-1.2-0.1-1.8-0.2c-1.1,0.1-2.1,0.2-3.1,0.2
		c-1.4-0.1-2.8-0.1-4.2-0.2c-0.5,0.1-0.9,0.1-1.3,0.2c-0.7,0-1.4,0-2,0c-0.8,0-1.7,0-2.5,0c-1.6,0-3.3-0.2-4.5,0.1
		c-1.8-0.1-4.2,0-5.9-0.1c-0.7-0.1-1.6-0.1-1.9,0c-0.4,0.1-1,0.1-1.9,0.1c-0.5,0-1,0.1-1.5,0.1c-0.4,0-0.7-0.1-1.1-0.1
		c-0.4,0-0.7-0.1-0.8-0.1c-0.6,0-1.2,0.1-1.7,0.1c-1.3,0-2.5-0.1-3.7-0.1c-2.1,0-3,0-3.9,0.3c-0.1,0-0.5,0-0.9,0
		c0.1-0.1,0.1-0.2,0.2-0.3c-1.1,0-1.9,0-2.6,0.1c-0.6,0-1.5,0-1.8,0c-0.5,0-0.7-0.1-1.2-0.2c-1.1,0.1-2.1,0.2-3.3,0.3
		c-1,0-2.3,0-3.5-0.1c-2.9-0.1-2.9-0.1-4.5,0.1c-1-0.2-2.9-0.2-4.3-0.1c-1.3,0.1-2.4,0-3.6,0c-1.6,0-3.2-0.1-4.8,0
		c-1,0.1-1.9,0-2.8,0c-1.6-0.1-2.3,0-2.7,0.1c-3.2,0.1-5.6-0.2-8.8-0.2c0.3,0.1,0.5,0.1,0.7,0.2c-2.5,0.1-3.7-0.1-4.5-0.2
		c-1.5,0.1-2,0.1-4.1,0.1c-0.3,0-0.7,0-0.9,0c-1.3,0.2-2.4,0.1-3.7,0c-0.6,0-2.2,0-2.2,0c-0.4,0.2-2.1,0.1-2.4,0.1
		c-1.5,0.2-2.2-0.1-3.5,0c-1.2,0-2.4,0.1-3.9,0c-0.8-0.1-2.9,0-4.3,0c-1.9,0-3.1-0.1-4.7-0.2c-0.4,0.1-0.8,0.1-1.1,0.2
		c-1.1-0.1-2-0.1-3-0.2c-1.2,0.3-3.1,0.2-5.1,0.1c-0.8,0-1.7-0.1-2.9-0.1c0.3,0.1,0.5,0.1,0.9,0.2c-1.5,0-3.1,0-3.7-0.1
		c-1.6-0.2-2.6-0.1-4.5,0c-1.5,0.1-3.8,0.1-5.7,0.1c-0.9,0-1.8-0.1-2.8-0.2c-1.7,0.2-3,0.2-4.3,0.2c-2.1-0.1-6.1-0.1-7.9-0.1
		c-1.5,0-2.6,0-3-0.2c-0.1,0-0.4,0-0.9-0.1c0,0.1,0,0.1,0,0.2c-2.6,0-5-0.1-6.7-0.1C3.9,0.2,3,0.2,2.3,0.3C1.5,0.4,0.2,0.5,0,0.6
		l2.9,0.2c1.7,0,4.3,0.1,6.9,0.1c0-0.1,0-0.1,0-0.2c0.5,0,0.9,0,0.9,0.1c0.4,0.2,1.6,0.2,3.1,0.2c0.8,0,2,0,3.3,0c0.2,0,0.4,0,0.7,0
		c0,0,0,0,0,0c1.6,0,3.2,0,4.2,0.1c1.3,0,2.7,0,4.5-0.2c1,0.1,1.9,0.2,2.9,0.2c2,0,4.3,0,5.9-0.1c1.9-0.1,3-0.2,4.6,0
		C40.4,1,42.1,1,43.6,1c-0.4-0.1-0.6-0.2-0.9-0.2c1.2,0,2.1,0.1,3,0.1C47.8,0.9,49.8,1,51,0.7c0.2,0,0.3,0,0.5,0c0,0,0,0,0,0
		c0,0,0.3,0,0.8-0.1c0.1,0.1,0.3,0.1,0.2,0.1c0,0-0.1,0-0.1,0c0.6,0,1.1,0.1,1.8,0.1c0.4-0.1,0.7-0.1,1.1-0.2c1.7,0.1,3,0.2,4.9,0.2
		c1.4,0,3.6-0.1,4.4,0c1.6,0.1,2.9,0.1,4.1,0c1.3,0,2.1,0.2,3.6,0c0.3,0,2,0.1,2.4-0.1c0,0,0.3,0,0.7,0c-0.2,0-0.4-0.1-0.4-0.1
		c0,0,0.3,0,0.5-0.1c0.2,0,0.5,0,0.5,0.1c0,0-0.2,0-0.4,0.1c0.5,0,1.1,0,1.4,0c1.3,0.1,2.5,0.2,3.8,0c0.1,0,0.6,0,0.9,0
		c2.2,0,2.7,0,4.3-0.1C86.8,1,88,1.1,90.6,1c-0.2-0.1-0.4-0.1-0.7-0.2c3.3,0,5.8,0.3,9.1,0.2c0.4-0.2,1.2-0.2,2.8-0.1
		c1,0,1.8,0.1,2.9,0c1.6-0.1,3.3,0,4.9,0c1.2,0,2.4,0,3.7,0c1.5-0.1,3.4,0,4.4,0.1c1.7-0.2,1.7-0.2,4.6-0.1c1.2,0,2.6,0.1,3.6,0.1
		c1.2-0.1,2.2-0.2,3.4-0.3c0.5,0.1,0.7,0.2,1.2,0.2c0.3,0,1.2,0,1.9,0c0.8,0,1.5,0,2.7-0.1c-0.1,0.1-0.1,0.2-0.2,0.4
		c0.5,0,0.9,0,1,0c0.9-0.2,1.8-0.3,4-0.3c1.3,0,2.5,0.1,3.8,0.1c0.5,0,1.1,0,1.8-0.1c0.1,0,0.5,0.1,0.9,0.1c0.3,0,0.7,0.1,1.1,0.1
		c0.5,0,1-0.1,1.5-0.1c0.9,0,1.6,0,2-0.1c0.4-0.1,1.3-0.1,2,0c1.8,0.2,4.3,0,6.1,0.1c1.2-0.2,3-0.1,4.7-0.1c0.8,0,1.7,0,2.5,0
		c0.7,0,1.4,0,2.1,0C169,1,169.5,1,170,0.9c1.5,0.1,2.9,0.1,4.3,0.2c1-0.1,2-0.2,3.2-0.2c0.6,0.1,1.3,0.1,1.9,0.2
		c1.4,0.1,1.8-0.2,3.3-0.1c1,0,2.3,0,3.6,0.1c2.5-0.1,5.2-0.1,8.2,0c2,0.1,4.3,0,6.5-0.1c0.4,0.1,0.8,0.2,1.2,0.3
		c1.1-0.1,1.7-0.2,2.4-0.3c0.5,0.1,0.9,0.1,1.3,0.2c1.3-0.1,2.5-0.1,3.8-0.2c0.2,0,0.5,0.1,0.9,0.1c0.9,0,1.7-0.1,3.1-0.1
		c0.5,0.1,1,0.2,1.7,0.2c0,0,0.1,0,0.1,0c-0.4-0.1-0.2-0.2,0.2-0.3c0.3,0.1,0.5,0.1,0.8,0.2c1.4-0.1,2.2,0.1,3.1,0.2
		c1-0.1,1.3-0.3,3.7-0.2c1.8,0.1,2.7-0.1,4.1-0.2c1.3,0.2,3,0.3,5.3,0.2c0-0.1,0-0.1,0-0.1c2.5-0.1,5.1,0.2,7.5,0
		c1.4,0.1,2.7,0.2,4.2,0.3c0.4-0.1,0.9-0.2,1.3-0.3c2,0.2,4.9,0,6.7,0.2c0.8-0.1,1.4-0.2,2.3-0.3c0.3,0.3,0.7,0.3,3.6,0.2
		c1.5,0.1,2.9,0.3,4.6,0c0.1,0,1.3,0,2,0c1.4,0,2.8,0.1,4.3,0.1c0.3,0,0.5,0,0.8,0c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0
		c3.3,0.1,6.4,0,9.6,0c2.5,0,4.9,0.1,7.5,0c0.1,0,0.5,0.1,1,0.2c1.5-0.1,3.1-0.3,5.3-0.2c0.4,0,1.1,0,1.4,0c2.1-0.2,3.8-0.1,5.4,0.1
		c1.4-0.1,2.5-0.4,4.6-0.1c2.8-0.1,5.7,0.2,8.4,0c0.3,0,1.2,0,1.7,0c4.2,0.1,8.6,0.1,12.9,0.1c1,0,2.1-0.1,3.4-0.1
		c0.4,0,1,0.1,1.7,0.1c0.9,0,1.8,0,3-0.1c0.3,0.1,0.7,0.1,0.9,0.2c0.9-0.1,1.7-0.1,2.5-0.2c0.2,0,0.5,0,0.6,0
		c1.6,0.1,3.1,0.1,4.8,0.2c0.2-0.1,0.3-0.2,0.5-0.3c0.6,0,1.2,0,1.7,0.1c1.5,0.1,2.9,0.1,4.6,0.1c1.4,0,3,0,4.9,0.1
		c0.1,0,0.5-0.1,1-0.2c0.7,0.1,1.3,0.1,1.9,0.2c0.4,0,0.9,0,1.3,0c-0.2,0-0.4,0-0.6-0.1c0.7,0,1.2,0,1.7,0c0.2,0,0.5,0,0.8,0
		c0.1,0,0.2,0,0.3,0C363,1.1,363.6,1,364.9,1c0.1,0.1,0.2,0.2,0.3,0.3c-0.7,0-1.2,0-1.7,0c1.8,0.2,4.6,0,7,0.1
		c3.4-0.2,6.8-0.1,10.2,0c0.1-0.1,0.2-0.1,0.2-0.2c4.7,0.1,4.7,0.1,6.9,0c0.6,0,1.2,0.1,1.9,0.1c1.3,0,2.8,0,4.1,0.1
		c0.2,0,0.6,0,0.7,0c1.8-0.2,3.5-0.1,5.3,0c0.6,0,1.4,0,2.1,0c0.9,0,1.9,0,2.9,0c-0.2-0.2,1.2-0.2,2.7-0.2c0.2,0.1,0.5,0.1,0.8,0.2
		c0.9-0.1,1.4-0.2,2.2-0.2c1.2,0.1,2.3,0.1,3.6,0.2c0.5-0.2,2.1-0.2,3.7-0.1c1.1,0,2.1,0.1,3.1,0.1c1.6,0.1,2.6,0,3.2-0.1
		c1,0,1.9,0.1,2.9,0.1c0.9,0,1.8,0,3-0.1c1.7,0.2,4.5,0.1,7,0.1c2.5,0,4.8-0.1,7.4,0c1.2,0,2.9,0,4.8-0.1c0,0,0.3,0.1,0.6,0.1
		c1-0.1,1.5-0.1,2-0.1c0.5,0,1-0.1,1.7-0.1c0.6,0.1,1.1,0.1,1.7,0.2c3.2-0.1,6.3-0.1,9,0.2c0.4-0.1,0.6-0.2,1-0.4
		c1,0.1,1.7,0.2,3.3,0.2c2.3,0,4.7-0.1,7,0.1c0.7,0,1.9,0,2.9-0.1c0.6,0,1.2,0,1.7,0.1c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.7-0.3-2.4-0.3
		c-0.6,0-1.1-0.1-1.7-0.1C475.6,0.9,475,1,474.9,0.9z M19.2,0.7c-1.5,0-2.2,0-1.8-0.2C18.3,0.6,18.7,0.6,19.2,0.7z M27.9,0.4
		c-0.2,0-0.5,0-0.8,0c0.2,0,0.4,0,0.6-0.1c0.4,0,0.6,0,0.9,0.1C28.3,0.4,28.1,0.4,27.9,0.4z M39.4,0.7c0,0-0.4,0-0.6,0
		c-0.1,0-0.1-0.1-0.2-0.1c0.3,0,0.6,0,0.8,0C39.5,0.6,39.5,0.6,39.4,0.7z M47.7,0.6c-0.5-0.2-0.5-0.2,1.4-0.2
		C48.6,0.5,48.2,0.6,47.7,0.6z M80.3,0.9c0,0-0.4,0-0.6,0.1c-0.1,0-0.4-0.1-0.3-0.1c0,0,0.3,0,0.7-0.1C80.1,0.8,80.3,0.9,80.3,0.9z
		 M84.6,0.5c-0.3,0-0.6,0-0.9-0.1c0.2,0,0.5,0,0.9-0.1c0.3,0,0.5,0.1,0.8,0.1C85,0.4,84.7,0.5,84.6,0.5z M99.8,0.8
		c-0.3,0-0.5,0.1-0.6,0.1c-0.2,0-0.5,0-0.6-0.1c0,0,0.3,0,0.4-0.1C99.2,0.7,99.4,0.8,99.8,0.8z M215.7,0.9c-1.3,0-1.6,0-1.4-0.2
		C215,0.8,215.3,0.8,215.7,0.9z M275.4,0.8c0.5-0.1,1.1-0.2,2.7-0.1C277.5,0.8,277.2,0.9,275.4,0.8z"
            />
            <path
                fill={color}
                d="M220.9,1.6c-0.3,0-0.7-0.1-1.4-0.2C219.2,1.6,219.5,1.6,220.9,1.6z"
            />
            <path
                fill={color}
                d="M282.8,1.5c1.8,0.1,2.1,0,2.8-0.1C283.9,1.3,283.3,1.4,282.8,1.5z"
            />
            <path
                fill={color}
                d="M51.1,1.5c0.3,0,0.7,0,0.7,0c0,0-0.1-0.1-0.2-0.1c-0.5,0-0.8,0.1-0.8,0.1C50.8,1.5,51,1.5,51.1,1.5z"
            />
            <path fill={color} d="M47,1.3c0.5-0.1,0.9-0.1,1.5-0.2C46.5,1.2,46.5,1.2,47,1.3z" />
            <path
                fill={color}
                d="M37.7,1.4c0.2,0,0.6,0,0.6,0c0.1,0,0.1-0.1,0.1-0.1c-0.3,0-0.6,0-0.9,0C37.6,1.3,37.7,1.3,37.7,1.4z"
            />
            <path
                fill={color}
                d="M25.6,1c0.3,0,0.6,0,0.8,0c0.3,0,0.5,0,0.7-0.1c-0.3,0-0.5,0-0.9-0.1C26,1,25.8,1,25.6,1z"
            />
            <path
                fill={color}
                d="M84.2,1.1c0.3,0,0.6,0.1,0.9,0.1c0.2,0,0.5,0,0.8,0c-0.2,0-0.5-0.1-0.8-0.1C84.7,1,84.4,1.1,84.2,1.1z"
            />
            <path
                fill={color}
                d="M99.6,1.5c0,0,0.4,0,0.6,0.1c0.2,0,0.4,0,0.7-0.1c-0.3,0-0.6,0-0.8-0.1C99.9,1.4,99.6,1.5,99.6,1.5z"
            />
            <path
                fill={color}
                d="M116.6,2c0,0,0.4,0.1,0.7,0.1c0.3,0,0.7,0,0.7-0.1c0,0-0.2-0.1-0.7-0.2C116.9,1.9,116.6,2,116.6,2z"
            />
            <path
                fill={color}
                d="M80,1.6c0.2,0,0.6,0,0.7-0.1c0.1,0-0.2-0.1-0.4-0.1c-0.3,0-0.7,0.1-0.7,0.1C79.6,1.6,79.9,1.6,80,1.6z"
            />
            <path
                fill={color}
                d="M76.2,1.5c0,0-0.4,0-0.5-0.1c-0.2,0-0.5,0-0.5,0.1c0,0,0.3,0.1,0.5,0.1C76,1.5,76.3,1.5,76.2,1.5z"
            />
            <path
                fill={color}
                d="M84.1,2c0.2,0,0.5,0,0.7-0.1c-0.3,0-0.5,0-0.9-0.1c-0.2,0-0.4,0.1-0.6,0.1C83.6,2,83.8,2,84.1,2z"
            />
        </g>
    </svg>
);

FooterTopLine.propTypes = propTypes;
FooterTopLine.defaultProps = defaultProps;

export default FooterTopLine;
